import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom } from '@angular/core';
import { HammerModule } from '@angular/platform-browser';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import 'hammerjs';

import { ErrorNotifier } from '../error-logger';

/** App config. */
export const appConfig: ApplicationConfig = {
	providers: [
		provideHttpClient(withInterceptorsFromDi()),
		{
			provide: ErrorHandler,
			useClass: ErrorNotifier,
		},
		provideLottieOptions({
			player: () => player,
		}),
		importProvidersFrom(HammerModule),
	],
};
